export const normalizeUrl = (value: string) => {
  const trimmed = value.trim();
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
};

export const isValidLinkedin = (value: string) => {
  if (!value.trim()) return false;
  try {
    const { hostname, pathname } = new URL(normalizeUrl(value));
    const isLinkedinHost =
      hostname === 'linkedin.com' || hostname.endsWith('.linkedin.com');
    return isLinkedinHost && /^\/(in|pub)\/[^/]+/.test(pathname);
  } catch {
    return false;
  }
};

export const LINKEDIN_ERROR_MESSAGE =
  'Please enter a link to your LinkedIn profile (linkedin.com/in/…)';
